module.exports = __webpack_public_path__ + "static/img/bg.14ba3e8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bg.png
// module id = C34Q
// module chunks = 1